import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from "../utils/PjaxWrapper";
import SearchResults                    from "../components/SearchResults/SearchResults";

/**
 *
 * @param {string} hook
 * @param {string} searchPattern
 * @param {string} category
 * @param {object} resultCounts
 * @param {object} filterConfigs
 * @param {object} defaultFilters
 */
function run(hook, searchPattern, category, resultCounts, filterConfigs, defaultFilters) {
	const el = document.getElementById(hook);

	if (el) {
		render(
			<SearchResults searchPattern={searchPattern}
			               category={category}
			               resultCounts={resultCounts}
			               filterConfigs={filterConfigs}
			               defaultFilters={defaultFilters}
			/>,
			el
		);

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(el);
		});
	}


}

export {run};